"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFileDrop = exports.FileDropProvider = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var utils_1 = require("./utils");
var styles_less_1 = __importDefault(require("./styles.less"));
var FileDropContext = (0, react_1.createContext)({});
var FileDropProvider = function (_a) {
    var children = _a.children;
    var listeners = (0, react_1.useRef)([]);
    var _b = (0, react_1.useState)(false), active = _b[0], setActive = _b[1];
    var on = (0, react_1.useCallback)(function (type, listener) {
        listeners.current = __spreadArray(__spreadArray([], listeners.current, true), [[type, listener]], false);
    }, []);
    var off = (0, react_1.useCallback)(function (type, listener) {
        listeners.current = listeners.current.filter(function (_a) {
            var key = _a[0], value = _a[1];
            return key !== type || value !== listener;
        });
    }, []);
    var value = (0, react_1.useMemo)(function () { return ({ on: on, off: off }); }, [on, off]);
    var readFile = (0, react_1.useCallback)(function (file) {
        file
            .arrayBuffer()
            .then(function (buffer) {
            listeners.current
                .filter(function (_a) {
                var type = _a[0];
                return type === '*';
            })
                .forEach(function (_a) {
                var listener = _a[1];
                return listener(file, buffer, (0, utils_1.isFileTypeSupported)(buffer));
            });
            listeners.current
                .filter(function (_a) {
                var type = _a[0];
                return type !== '*' && (file.type ? type === file.type : (0, utils_1.isFileType)(buffer, type));
            })
                .forEach(function (_a) {
                var listener = _a[1];
                return listener(file, buffer, true);
            });
        })
            .catch(console.error);
    }, []);
    var onChange = function (event) {
        event.preventDefault();
        var input = event.target;
        if (input.files && input.files.length > 0) {
            readFile(input.files[0]);
        }
        setActive(false);
        input.files = new DataTransfer().files;
    };
    (0, react_1.useEffect)(function () {
        var dragDepth = 0;
        var onDragStart = function (event) {
            event.preventDefault();
        };
        var onDragEnter = function (event) {
            var _a;
            if (!((_a = event.dataTransfer) === null || _a === void 0 ? void 0 : _a.types.includes('Files')))
                return;
            event.preventDefault();
            dragDepth += 1;
            setActive(true);
        };
        var onDragOver = function (event) {
            var _a;
            if ((_a = event.dataTransfer) === null || _a === void 0 ? void 0 : _a.types.includes('Files'))
                event.preventDefault();
        };
        var onDragLeave = function () {
            dragDepth = Math.max(0, dragDepth - 1);
            if (dragDepth === 0)
                setActive(false);
        };
        var onDrop = function (event) {
            var _a;
            if (!((_a = event.dataTransfer) === null || _a === void 0 ? void 0 : _a.types.includes('Files')))
                return;
            event.preventDefault();
            dragDepth = 0;
            setActive(false);
            var file = event.dataTransfer.files[0];
            if (file)
                readFile(file);
        };
        window.addEventListener('dragstart', onDragStart);
        window.addEventListener('dragenter', onDragEnter);
        window.addEventListener('dragover', onDragOver);
        window.addEventListener('dragleave', onDragLeave);
        window.addEventListener('drop', onDrop);
        return function () {
            window.removeEventListener('dragstart', onDragStart);
            window.removeEventListener('dragenter', onDragEnter);
            window.removeEventListener('dragover', onDragOver);
            window.removeEventListener('dragleave', onDragLeave);
            window.removeEventListener('drop', onDrop);
        };
    }, [readFile]);
    return (react_1.default.createElement(FileDropContext.Provider, { value: value },
        children,
        react_1.default.createElement("div", { className: (0, classnames_1.default)(styles_less_1.default['file-drop-container'], { 'active': active }) },
            react_1.default.createElement("input", { type: 'file', className: styles_less_1.default['file-input'], onChange: onChange }))));
};
exports.FileDropProvider = FileDropProvider;
var useFileDrop = function () {
    return (0, react_1.useContext)(FileDropContext);
};
exports.useFileDrop = useFileDrop;
